"use client";

import { c as _c } from "react/compiler-runtime";
import { ExpandAll, ExpandLess, ExpandMore } from "../../icons";
import { classNames } from "../../utils";
import { CenterAligned } from "../CenterAligned";
import { textLabelVariants } from "../Text/TextLabel";
import { TableCell } from "./TableCell";
const getIconComponent = sortOrder => {
  switch (sortOrder) {
    case "asc":
      return ExpandLess;
    case "desc":
      return ExpandMore;
    case undefined:
      return ExpandAll;
  }
};
const SortIcon = t0 => {
  const $ = _c(4);
  const {
    sortOrder
  } = t0;
  let t1;
  if ($[0] !== sortOrder) {
    t1 = getIconComponent(sortOrder);
    $[0] = sortOrder;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const IconComponent = t1;
  let t2;
  if ($[2] !== IconComponent) {
    t2 = <IconComponent size={12} />;
    $[2] = IconComponent;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  return t2;
};
export const TableHeaderCell = t0 => {
  const $ = _c(19);
  let cellProps;
  let children;
  let className;
  let sort;
  if ($[0] !== t0) {
    ({
      children,
      sort,
      className,
      ...cellProps
    } = t0);
    $[0] = t0;
    $[1] = cellProps;
    $[2] = children;
    $[3] = className;
    $[4] = sort;
  } else {
    cellProps = $[1];
    children = $[2];
    className = $[3];
    sort = $[4];
  }
  const t1 = sort && "cursor-pointer";
  const t2 = sort?.order ? "font-medium text-text-primary" : "text-text-secondary";
  let t3;
  if ($[5] !== className || $[6] !== t1 || $[7] !== t2) {
    t3 = classNames(t1, t2, textLabelVariants({
      size: "xs"
    }), className);
    $[5] = className;
    $[6] = t1;
    $[7] = t2;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  let t4;
  if ($[9] !== sort) {
    t4 = () => sort?.onSort({
      column: sort.column,
      order: sort.order === "desc" ? "asc" : "desc"
    });
    $[9] = sort;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  let t5;
  if ($[11] !== sort) {
    t5 = sort && <CenterAligned className="relative left-[3px]"><SortIcon sortOrder={sort.order} /></CenterAligned>;
    $[11] = sort;
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  let t6;
  if ($[13] !== cellProps || $[14] !== children || $[15] !== t3 || $[16] !== t4 || $[17] !== t5) {
    t6 = <TableCell className={t3} onClick={t4} role="columnheader" {...cellProps}>{children}{t5}</TableCell>;
    $[13] = cellProps;
    $[14] = children;
    $[15] = t3;
    $[16] = t4;
    $[17] = t5;
    $[18] = t6;
  } else {
    t6 = $[18];
  }
  return t6;
};